import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { defaultSSOErrorMessage } from "@faire/retailer-visitor-shared/components/SocialSignOnButtons/errorMessages";
import { useSSOContextStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/SSOContextStore";
import { useCallback } from "react";
export var useSSOErrorStore = function() {
    var _useSSOContextStore = _sliced_to_array(useSSOContextStore([
        "errorMessage",
        "strictLocalize"
    ]), 2), _useSSOContextStore_ = _useSSOContextStore[0], errorMessage = _useSSOContextStore_.errorMessage, strictLocalize = _useSSOContextStore_.strictLocalize, setStore = _useSSOContextStore[1];
    var setErrorMessage = useCallback(function(message) {
        setStore({
            errorMessage: message
        });
    }, [
        setStore
    ]);
    // This store is linked to the SSOContextStore and is used to manage the error message state.
    // We need to pass the strict localization function in at a later point because it is initialized prior to localization provider.
    var setStrictLocalize = useCallback(function(strictLocalize) {
        setStore({
            strictLocalize: strictLocalize
        });
    }, [
        setStore
    ]);
    var setLocalizedErrorMessage = useCallback(function() {
        if (strictLocalize) {
            setErrorMessage(defaultSSOErrorMessage(strictLocalize));
        }
    }, [
        setErrorMessage,
        strictLocalize
    ]);
    var resetErrorMessage = useCallback(function() {
        setStore({
            errorMessage: ""
        });
    }, [
        setStore
    ]);
    return {
        errorMessage: errorMessage,
        strictLocalize: strictLocalize,
        setErrorMessage: setErrorMessage,
        setLocalizedErrorMessage: setLocalizedErrorMessage,
        resetErrorMessage: resetErrorMessage,
        setStrictLocalize: setStrictLocalize
    };
};
